<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <label class="label-input">Section</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.background.color"
                    @change="e => (fields.background.color = e.target.value)"
                  />
                  <v-text-field v-model="fields.background.color" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="e => (fields.textColor = e.target.value)"
                  />
                  <v-text-field v-model="fields.textColor" label="Text Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.padding.top" label="Top Padding" />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Review card background</label>
          <div class="group-item">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields.wrapItems.backgroundItem"
                @change="e => (fields.wrapItems.backgroundItem = e.target.value)"
              />
              <v-text-field v-model="fields.wrapItems.backgroundItem" label="Background Item" />
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-3">
            <label class="label-input mb-0">Reviews</label>
            <v-btn small color="primary" @click="handleAddItem">
              <v-icon size="16" left>mdi-plus</v-icon>
              Add Review
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields.wrapItems.listItem" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span>{{ item.userName || `Review ${i + 1}` }}</span>
                  <v-btn icon small @click.stop="handleRemoveItem(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="pa-2">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="item.userName" label="User Name" class="mb-3" />
                    </v-col>
                    <v-col cols="12" md="6">
                      <div style="gap: 10px" class="d-flex align-center gap-6 mb-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px"
                          :value="item.verifiedColor"
                          @change="e => (item.verifiedColor = e.target.value)"
                        />
                        <v-text-field v-model="item.verifiedColor" label="Verified Badge Color" />
                      </div>
                    </v-col>
                  </v-row>

                  <div style="gap: 30px" class="mb-3 d-flex align-center">
                    <div style="gap: 10px" class="d-flex align-center">
                      <label :for="`showRating-${i}`" style="margin-bottom: 0" class="label-reating">Rating</label>
                      <input type="checkbox" v-model="item.showRating" :id="`showRating-${i}`" />
                    </div>
                    <v-rating
                      color="warning"
                      background-color="#c1c1c1"
                      empty-icon="mdi-star-outline"
                      full-icon="mdi-star"
                      half-icon="mdi-star-half-full"
                      hover
                      length="5"
                      size="35"
                      :value="item.valueStart"
                      @input="val => (item.valueStart = val)"
                    />
                  </div>
                  <v-text-field v-model="item.titleReview" label="Title Review" class="mb-3" />
                  <v-textarea v-model="item.descriptionReview" label="Description Review" rows="4" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'ReviewGrid03',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: {
        title: 'Review Grid Section 03',
        textColor: '#000000',
        enableAnchor: false,
        padding: { top: true, bottom: true },
        background: { color: '#ffffff' },
        wrapItems: {
          backgroundItem: '#ded4d4',
          listItem: [
            {
              valueStart: 5,
              showRating: true,
              userName: 'Bobby M.',
              verifiedColor: '#66CEAA',
              titleReview: '"I Saw 47 PPM. My Old Detector? Silent."',
              descriptionReview:
                "\"We had a 'working' detector for 6 years. Green light. Beeped when I tested it. Then I got Haven just to double-check. First night: 47 PPM in my son's bedroom. My old detector? Still glowing green. Still silent. I unplugged it and threw it in the trash. Haven probably saved my son's life.\"",
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.fields = { ...this.fields, ...this.sectionEditor.sectionExtract };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionReviewGridSection03(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html,
      });
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.wrapItems.listItem.push({
        valueStart: 5,
        showRating: true,
        userName: '',
        verifiedColor: '#66CEAA',
        titleReview: '',
        descriptionReview: '',
      });
    },
    handleRemoveItem(index) {
      this.fields.wrapItems.listItem.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.label-reating {
  font-size: 14px;
  font-weight: 500;
  color: #000;
  margin-bottom: 0;
  display: block;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0 0 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0 0 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
